import React from 'react'

const NavItem = ({ active = '', name = '', value = '', selected = false }) => (
    <li className="nav-item">
        <a className={`nav-link ${active}`}
            id={`${name}-tab`}
            data-toggle="tab"
            href={`#${name}`}
            role="tab"
            aria-controls={name}
            aria-selected={ selected ? 'true':'false' }
            data-bs-toggle="tab"
        >
            { value || name.charAt(0).toUpperCase() + name.substr(1) }
        </a>
    </li>
)

export default  NavItem


// WEBPACK FOOTER //
// ./src/components/utilities/NavItem.js